/**
 * Localización de las etiquetas de formato de producto ("Biberón 900g",
 * "CRISTAL 320g | 530g", "Garrafa 1.850g").
 *
 * Los formatos de `data/` son identificadores en español (además de texto
 * visible): `formats` es la clave de `formatImages` y del formato
 * seleccionado, así que no se traducen en el dato. Se localizan solo al
 * mostrarlos: se traduce el tipo de envase (glosario de traducciones) y el
 * separador de miles, que en español es un punto ("1.850g") y en inglés se
 * leería como decimal. Las cifras y unidades (g, ml, PE) no cambian.
 */

import { DEFAULT_LANGUAGE } from '../../i18n/languages';

/** Tipo de envase por idioma. Debe seguir el glosario (`docs/glosario-traducciones.md`). */
const CONTAINER_WORDS = {
  CRISTAL: { en: 'GLASS', fr: 'VERRE', pt: 'VIDRO' },
  Biberón: { en: 'Squeeze bottle', fr: 'Flacon souple', pt: 'Frasco doseador' },
  Garrafa: { en: 'Jug', fr: 'Bidon', pt: 'Garrafão' },
  Cubo: { en: 'Bucket', fr: 'Seau', pt: 'Balde' },
  Lata: { en: 'Can', fr: 'Boîte', pt: 'Lata' },
};

/** Separador de miles por idioma (el español del dato usa el punto). */
const THOUSANDS_SEPARATOR = { en: ',', fr: ' ', pt: ' ' };

const CONTAINER_PATTERN = new RegExp(`(?<!\\p{L})(${Object.keys(CONTAINER_WORDS).join('|')})(?!\\p{L})`, 'gu');
const THOUSANDS_PATTERN = /\d{1,3}(?:\.\d{3})+/g;

/**
 * Traduce una etiqueta de formato al idioma pedido.
 *
 * @param {string} label - Formato en español, p. ej. `'Cubo 5.000g'`
 * @param {string} [lang] - Código de idioma activo
 * @returns {string} Etiqueta localizada; en español (o idioma desconocido) se devuelve igual
 */
export const localizeFormatLabel = (label, lang) => {
  if (typeof label !== 'string' || !lang || lang === DEFAULT_LANGUAGE || !THOUSANDS_SEPARATOR[lang]) {
    return label;
  }
  return label
    .replace(CONTAINER_PATTERN, (word) => CONTAINER_WORDS[word][lang])
    .replace(THOUSANDS_PATTERN, (number) => number.replace(/\./g, THOUSANDS_SEPARATOR[lang]));
};
